export default {
  'form.name': '客户姓名',
  'form.name.placeholder': '请输入客户姓名',
  'form.mobile': '手机号',
  'form.mobile.placeholder': '请输入手机号',
  'form.nickname': '用户昵称',
  'form.nickname.placeholder': '请输入昵称',
  'form.hospital': '查重医院',
  'form.hospital.placeholder': '请输入医院',
  'form.state': '回访状态',
  'form.state.all': '全部',
  'form.state.followed': '已回访',
  'form.state.unfollowed': '未回访',
  'form.consume_status': '消费状态',
  'form.consume_status.all': '全部',
  'form.consume_status.consumed': '已消费',
  'form.consume_status.unconsumed': '未消费',
  'form.chooseDate': '选择日期',
  'form.date_range': '日期范围',
  'form.followUpStaff': '回访人',
  'form.followUpStaff.placeholder': '请选择回访人',
  'form.columns.index': '序号',
  'form.columns.is_today_contact': '今日联系',
  'form.columns.operations': '操作',
  'form.columns.operations.edit': '编辑',
  'form.keyword': '关键词',
  'form.keyword.placeholder': '请输入电话号码或姓名',
  'form.columns.operations.follow_up_record': '回访记录',
  'form.columns.operations.follow_up_plan': '回访计划',
  'form.addCustomer.source': '客户来源',
  'form.addCustomer.source.placeholder': '请输入客户来源',
  'form.addCustomer.laiyuan': '获客渠道',
  'form.addCustomer.laiyuan.placeholder': '请输入获客渠道',
  'form.addCustomer.city': '所在城市',
  'form.addCustomer.city.placeholder': '请输入城市',
  'form.addCustomer.mobile': '用户电话',
  'form.button.search': '搜索',
  'form.button.reset': '重置',
  'form.result_level': '回访结果',
  'form.result_level.placeholder': '请选择回访结果',
  'form.follow_up_content': '回访内容',
  'form.follow_up_content.placeholder': '请输入回访内容',

  // 报备
  'report.form.reporter.mobile': '报备人手机号',
  'report.form.reporter.nickname': '报备人昵称',
  'report.form.customer.mobile': '客户手机号',
  'report.form.customer.nickname': '客户昵称',
  'report.form.customer.project': '项目',
  'report.form.state': '查重状态',
  'report.form.state.all': '全部',
  'report.form.state.not_checked': '待处理',
  'report.form.state.duplicate': '重单',
  'report.form.state.not_duplicate': '不重单',
  'report.form.state.duplicate_deep': '重单可深度',
  'report.form.state.create_time': '报备时间',
  'report.form.remark': '备注',
  'report.form.images': '备注图片',

  'customer.columns.nickname': '客户昵称',
  'customer.columns.mobile': '手机号',
  'customer.columns.project': '项目',
  'customer.columns.city': '城市',
  'customer.columns.distribute': '分配状态',
  'customer.columns.addTime': '添加时间',
  'customer.columns.createTime': '注册时间',
  // 批量分配
  'customer.operation.distributeMultiple': '批量分配',
  'customer.operation.distributeRandom': '随机分配',
  'customer.operation.distribute': '分配',
  'customer.operation.reDistribute': '重新分配',
  'customer.operation.distributed': '已分配',
  'customer.operation.unDistributed': '未分配',
  'customer.operation.claim': '认领',
  'customer.operation.claimSuccess': '认领成功',
  'customer.operation.setInvalid': '设为无效',
  'customer.operation.setInvalidConfirm': '确定要将该客户设为无效吗？',
  'customer.operation.setInvalidSuccess': '已设为无效',
  'customer.operation.reportNoMobile': '该用户尚无电话号码，请先添加',
  'customer.operation.editTitle': '编辑客户',
  'customer.operation.editSuccess': '编辑客户成功',
  'customer.operation.invalidTag': '无效',
  'customer.operation.invalidAlert': '该客户已被标记为无效，请谨慎处理',
  'customer.operation.mobileLockedHint': '电话号码已存在，保存后不可修改',
  'customer.operation.mobileLockedError': '电话号码不能修改',
  'customer.operation.mobileWarningTitle': '提示',
  'customer.operation.mobileFirstFillWarning':
    '电话号码保存后不能再修改，请谨慎填写！',
  'customer.operation.modal.chooseStaff': '选择接收人',
  'customer.error.noCustomer': '请选择需要分配的客户',
  'customer.error.fetchDataFailed': '获取客户数据失败',

  'form.columns.operations.msgRecord': '沟通记录',
};
